

















import Vue from 'vue'
import InfoTooltip from '@/UI/Shared/InfoTooltip.vue'

export default Vue.extend({
  name: 'SpeciesOfferTableHeader',
  components: { InfoTooltip },
  props: {
    volumenUnit: {
      type: String,
      required: true
    }
  }
})
